import React, { useMemo } from "react";
import logoImage from "./mscan-rivile-black.svg";
import logoImageDark from "./mscan-logo-rivile 1.svg";
import { useColorScheme } from "@mui/material/styles";

interface ILogo {
  src?: string;
  width?: string;
}

function Logo(props: ILogo) {
  const { src, ...rest } = props;
  const { mode } = useColorScheme();

  const logo = useMemo(
    () => (mode === "dark" ? logoImageDark : logoImage),
    [mode]
  );

  return <img src={src ? src : logo} alt="Rivile-mscan" {...rest} />;
}

export default Logo;
